<res-base-modal modalTitle="Run As Combined Search" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    primaryButtonLabel="Search" (primaryButtonActionEmt)="search()" [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()"
    (closeButtonActionEmt)="closeModal()" [modalHasVariableHeight]="!showTargetSelector" secondaryButtonLabel="Cancel"
    [modalHelpIndex]="modalHelpIndex" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage">

    <div class="modal-row">
        <div class="modal-row-column-auto">
            <label>Combine Operator:</label>
        </div>
        <div class="modal-row-column-max">
            <button [attr.data-automation-id]="modalAutomationId + '-or-button'" type="button" [disabled]="queryEdited"
                [ngClass]="operationType == 'OR' ? 'btn-group-active' : 'btn-group-default'"
                (click)="setOperationType('OR')">
                <div>OR</div>
                <i class="fa fa-caret-up up-caret-active" [hidden]="operationType != 'OR'"></i>
            </button>
            <button [attr.data-automation-id]="modalAutomationId + '-and-button'" [disabled]="queryEdited" type="button"
                [ngClass]="operationType == 'AND' ? 'btn-group-active' : 'btn-group-default'"
                (click)="setOperationType('AND')">
                <div>AND</div>
                <i class="fa fa-caret-up up-caret-active" [hidden]="operationType != 'AND'"></i>
            </button>
        </div>
    </div>
    <div class="modal-row query-row">
        <div class="modal-row-column-auto">
            <label>Search Query:</label>
        </div>
        <div class="modal-row-column-max query-column">
            <res-generic-input #queryInput [queryString]="queryString" [colorizeOnQueryChange]="false"
                [keyPressEvent]="keyPressEvent.bind(this)" [inputChangedEvent]="inputChanged.bind(this)"
                [automationId]="'run-as-combined-search'">
            </res-generic-input>
            <button [class.query-visible]="queryString.trim()" [class.query-clear]="!queryString.trim()"
                [attr.data-automation-id]="modalAutomationId + '-input-clear-button'" (click)="onClearQuery()"
                [ngClass]="[checkHasScroll() ? 'clear-button-with-scroll' : '']">
                <i class="fa fa-times" [class.fa-times]="queryString.trim()"></i>
            </button>
        </div>
    </div>
    <div class="modal-row" *ngIf="showTargetSelector">
        <div class="modal-row-column-auto">
            <label>Search Target:</label>
        </div>
        <div class="modal-row-column-max target-row">
            <div class="target-picker">
                <input type="text" title="{{searchTarget.name}}" readonly class="read-only"
                    [ngModel]="searchTarget.name"
                    [attr.data-automation-id]="modalAutomationId + '-search-target-input'">
                <i class="fa fa-filter filter-indicator" [title]="corporaFilterTooltip"
                    *ngIf="corporaFilters && corporaFilters.length > 0"
                    [attr.data-automation-id]="modalAutomationId + '-data-sets-filter-indicator'"></i>
                <button type="button" class="primary-button target-button" (click)="openTargetSelector()"
                    [attr.data-automation-id]="modalAutomationId + '-search-target-button'"><i
                        class="fa fa-crosshairs"></i>Select Target ...
                </button>
            </div>
            <res-collapsible-toggle-box-group [toggleItems]="searchOptions" [automationId]="modalAutomationId">
            </res-collapsible-toggle-box-group>
        </div>
    </div>
</res-base-modal>